export enum EventKind {
    LayerCreated = "layer.created",
    LayerDeleted = "layer.deleted",
    EntityCreated = "entity.created",
    EntityDeleted = "entity.deleted",
    StreamStarted = "stream.started",
    StreamEnded = "stream.ended",
    StreamShared = "stream.shared",
    LocationSharingStarted = "location_sharing.started",
    LocationSharingEnded = "location_sharing.ended",
    MissionGroupStreamShared = "stream.mission_group_shared",
    MissionGroupDashboardShared = "stream.mission_group_dashboard_shared",
    PdfGenerated = "pdf.generated",
    PdfFailed = "pdf.failed",
    LayerProcessed = "layer.processed",
    LayerProcessingFailed = "layer.processing_failed",
    AccessRequested = "access.requested",
    AccessGranted = "access.granted",
    AccessRemoved = "access.removed",
    LayerArchived = "layer.archived",
    LayerUnarchived = "layer.unarchived",
    EntityArchived = "entity.archived",
    EntityUnarchived = "entity.unarchived",
    CommentCreated = "comment.created",
    CommentDeleted = "comment.deleted",
}

export enum ProcessingHandlerType {
    LiveVideoDelayShutdown = "liveVideoDelayShutdown",
    ImportImages = "importImages",
    AddLicenseUsage = "addLicenseUsage",
    DispatchStitch = "dispatchStitch",
    Event = "event",
    DeliverUserChannelMessage = "deliverUserChannelMessage",
}
